<template>
    <Page header="Пользователь">
        <template v-slot:body>
            <div class="w-full flex flex-column mb-3">
                <SelectButton v-model="userView" :options="viewList" optionLabel="name" optionValue="value" aria-labelledby="basic" />
            </div>
            <div v-if="user" class="w-full flex flex-column gap-3 mb-4" >
                <UserDetail :user="user" @update="LoadUser(user_id)"/>
            </div>
            <Skeleton v-if="loading" height="2rem" />
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import { useRoute } from 'vue-router'
import Page from "@/components/sides/Page.vue"
import UserDetail from '@/components/admin/user/detail.vue'

export default {
    data() {
        return {
            user: null,
            loading: false,
            // user_id: null,
            viewList: [
                { name: 'Внутренний', value: 'inner' },
                { name: 'Внешний', value: 'outer' }
            ],
            userView: null,
        }
    },
    components: {
        Page,
        UserDetail
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(path) {
                if(!path || typeof path !== 'string') return
                if(path.startsWith('/admin/user_wallet/')) {
                    this.userView = 'outer'
                    return
                }
                if(path.startsWith('/admin/user/')) {
                    this.userView = 'inner'
                }
            }
        },
        userView(val) {
            // Переключаем между внутренним и внешним профилем без лишних переходов.
            if (val === 'outer' && !this.$route.path.startsWith('/admin/user_wallet/') && 
                (this.user?.ledger_id || this.user_id)) {
                this.$router.push({ path: `/admin/user_wallet/${this.user?.ledger_id || this.user_id}` })
                return
            }
            if(val === 'inner' && this.user_id && !this.$route.path.startsWith('/admin/user/')) {
                this.$router.push({ path: `/admin/user/${this.user_id}` })
            }
        }
    },
    methods: {
        async LoadUser(id){
            this.loading = true
            try {
                const res = await this.connect.AdminGetUserById(id, {}).then(res=>res)
                if(res.result) {
                    this.user = res.data
                    this.verified = (this.user.verified) ? true : false
                }
                else this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: res.message, life: 3000 })
            } catch (error) {
                console.log(error)
            } finally {
                this.loading = false
            }
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)) this.user_id = route.params.id
    },
    mounted(){
        if(this.user_id) {
            this.LoadUser(this.user_id)
        }
    }
}
</script>
